import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { updateMetaTags } from '../../utils/meta-tags-updater'
import { API } from '../../interceptors/axios';

const MetaTagsManager = () => {
  const location = useLocation();
  const params = useParams();
  const path = location.pathname;

  useEffect(() => {
    const fetchMetaData = async () => {
      // Default values for fallback
      let metaData = {
        title: 'Distorise Music',
        description: 'Discover unique and engaging music on Distorise Music',
        imageUrl: `${process.env.REACT_APP_API_URL || 'https://api.distorise.com'}/default-preview.jpg`,
        type: 'website'
      };

      try {
        // Check which route is active and fetch appropriate data
        if (path.startsWith('/release/')) {
          const slug = path.split('/')[2];
          if (!slug) return;

          // console.log(`Fetching meta data for slug: ${slug}`);

          // Extract song ID from slug
          const parts = slug.split('-');
          const songId = parts[parts.length - 1];
          const songTitle = parts.slice(0, -1).join('-');

          // Try to fetch blog data for this song
          try {
            // console.log(`Fetching blog data for song ID: ${songId}`);
            const response = await API.get(`${process.env.REACT_APP_API_URL || 'https://api.distorise.com'}/public-blog-info/${songTitle}`);
            const blogData = response.data;
            
            metaData = {
              title: blogData.title || `Distorise Music - ${songTitle.replace(/-/g, ' ')}`,
              description: blogData.content?.substring(0, 150) + '...' || 'Listen to this track on Distorise Music',
              imageUrl: `${process.env.REACT_APP_API_URL || 'https://api.distorise.com'}/public-preview/${songId}.jpg?v=${Date.now()}`,
              type: 'music.song'
            };
          } catch (error) {
            // console.log('Falling back to basic song preview');
            // Use basic song preview if blog data isn't available
            metaData = {
              title: `Distorise Music - ${songTitle.replace(/-/g, ' ')}`,
              description: 'Listen to this track on Distorise Music',
              imageUrl: `${process.env.REACT_APP_API_URL || 'https://api.distorise.com'}/public-preview/${songId}.jpg?v=${Date.now()}`,
              type: 'music.song'
            };
          }
        } else if (path === '/') {
          // Home page
          metaData = {
            title: 'Distorise Music - Home',
            description: '!!! Discover the latest music and articles on Distorise Music',
            imageUrl: `${process.env.REACT_APP_API_URL || 'https://api.distorise.com'}/default-preview.jpg`,
            type: 'website'
          };
        }
      } catch (error) {
        console.error('Error fetching meta data:', error);
      }

      // Update meta tags with the data we've gathered
      updateMetaTags({
        title: metaData.title,
        description: metaData.description,
        imageUrl: metaData.imageUrl,
        pageUrl: window.location.href,
        type: metaData.type
      });

      // console.log(`Meta tags updated for route: ${path}`);
    };

    fetchMetaData();

    // Clean up meta tags when component unmounts
    return () => {
      // You could reset to defaults here if needed
    };
  }, [path, params]);

  // This component doesn't render anything
  return null;
};

export default MetaTagsManager;